import { collection, doc, query, where, getDocs, getDoc, setDoc } from "firebase/firestore";

import { get, set, clear } from "./state";
import db from "./db";

const h = async (input) => {
  const textAsBuffer = new TextEncoder().encode(input);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash = hashArray
    .map((item) => item.toString(16).padStart(2, "0"))
    .join("");

  return hash === "4cd1a3c10dc64f75eecc760bc0d461d5a20d171c46f4500896afbd090f9bfe95";
};

const setFavoriteBook = (book) => {
  set("favoriteBook", book);
}

const getFavoriteBook = () => {
  return get("favoriteBook");
}

const clearFavoriteBook = () => {
  clear("favoriteBook");
}

const getAvailableBooks = async () => {
  const availableBooks = await getDocs(query(collection(db, "books"), where("available", "==", true)));

  return availableBooks.docs.map((book) => { return {"id": book.id, ...(book.data())} });
}

const getBook = async (bookID) => {
  const book = await getDoc(doc(db, "books", bookID));

  return (book.exists()) ? {"id": book.id, ...(book.data())} : null;
}

const addBook = async (book) => {
  await setDoc(doc(db, "books", book.id), {
    author: book.author,
    available: true,
    description: book.description,
    price: book.price,
    subtitle: book.subtitle,
    thumbnail: book.thumbnail,
    title: book.title,
    tradeID: null,
    sender: null,
    comment: null
  });
}

const decode = (string) => {
  return string.replace("&#39;", "’");
}

export { setFavoriteBook, getFavoriteBook, clearFavoriteBook, getAvailableBooks, getBook, addBook, decode, h };
